'use client';

import type { HandleChangeAnswerType } from '../model';
import type { AnswerUserType } from '~/model/AnswerUserType';
import { useTranslations } from 'next-intl';
import { useLayoutEffect } from 'react';
import { getIdFromUri } from '@/app/utils/entities/uri';
import { useFocus } from '~/hooks/useFocus';

export const IntegerTypeQuestion = ({
  answerUser,
  questionId,
  handleChangeAnswer,
  type,
  disabled = false,
}: {
  answerUser: AnswerUserType;
  questionId: string;
  handleChangeAnswer: HandleChangeAnswerType;
  type: string;
  disabled?: boolean;
}) => {
  const t = useTranslations('FORM');
  const [inputRef, setInputFocus] = useFocus();

  const IntegerRegExp = /^[+-]?\d+$/;

  const handleValidationOnChange = (e) => {
    const { value } = e.target;

    if (value === '' || IntegerRegExp.test(value))
      handleChangeAnswer(value, questionId, type, null);
  };

  useLayoutEffect(() => {
    setInputFocus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputRef.current]);

  return (
    <div className="vtmn-text-input_container">
      <input
        ref={inputRef}
        id={`question-${getIdFromUri(questionId)}`}
        data-testid="integer"
        data-cy="integer"
        type="number"
        inputMode="numeric"
        pattern="[0-9]*"
        className="vtmn-text-input"
        value={
          answerUser[questionId] != null
            ? (answerUser[questionId].value as string)
            : ''
        }
        required
        aria-label={t('PLACEHOLDER_INTEGER')}
        placeholder={t('PLACEHOLDER_INTEGER')}
        onChange={handleValidationOnChange}
        maxLength={9}
        disabled={disabled}
      />
    </div>
  );
};
